<template>
<div>
  <v-card v-if="!backendconnection" color="primary" class="mb-10">
    <v-row dense>
      <v-col >
         <v-avatar
                class="ma-3"
                size="80"
                color="white"
              >
                <v-icon size=45>mdi-door-closed-lock</v-icon>
              </v-avatar>
      </v-col>
      <v-col cols="11">
          <v-card-title>Diese Ressource ist derzeit nur innerhalb des Netzwerks des Technischen Universität Hamburg erreichbar.</v-card-title>
          <v-card-text>Stellen Sie bitte eine Verbindung zum internen Netzwerk der TUHH her (bspw. via VPN).</v-card-text>
      </v-col>
    </v-row>
  </v-card>
    <v-card v-if="!backendconnection" color="primary" class="mb-10">
    <v-row dense>
      <v-col>
         <v-avatar
                class="ma-3"
                size="80"
                color="white"
              >
                <v-icon size=45>mdi-door-closed-lock</v-icon>
              </v-avatar>
      </v-col>
      <v-col cols="11">
        <v-card-title>This resource is currently only accessible within the network of the Hamburg University of Technology.</v-card-title>
        <v-card-text>Please establish a connection to the internal network of the TUHH (e.g. via VPN).</v-card-text>
      </v-col>
    </v-row>
  </v-card>
</div>
</template>

<script>
import APIService from '@/services/APIService'
export default {
  data () {
    return {
      backendconnection: false
    }
  },
  methods: {
    async getLiveness () {
      const response = await APIService.livenessProbe()
      console.log(response.status)
      this.backendconnection = response.status === 200
    }
  },
  mounted () {
    this.getLiveness()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/backendConnectionComponent.vue